export default __webpack_public_path__ + "static/media/IMG-20241210-WA0038.95bbb415.jpg";